import React from 'react';
import PropTypes from 'prop-types';

import { IRON } from '@constant/colors';

const Processing = ({ className }) => (
  <svg className={className} viewBox="0 0 171 171">
    <g fill={IRON} fillRule="evenodd">
      <circle cx="55" cy="85" r="8" />
      <circle cx="85" cy="85" r="8" />
      <circle cx="115" cy="85" r="8" />
    </g>
  </svg>
);

Processing.propTypes = {
  className: PropTypes.string,
};

export default Processing;
